import React from 'react';
import { Mouvement } from '@mairistem/comptabilite';
import CompteDeTiersComponent from '../../../components/Mouvement/Panel/CompteDeTiersComponent';
import CODE_PANEL from '../../../constants/mouvements/codePanel';
import LignePanel from './LignePanel';

class CompteDeTiersPanel extends LignePanel {
  constructor(isMandatory = false) {
    super(isMandatory);
    this.code = CODE_PANEL.COMPTE_DE_TIERS;
    this.icon = { name: 'user doctor' };
  }

  getLibelle = () => 'Compte de tiers';

  isEmpty = (data: Mouvement) => !data?.lignes?.find((ligne) => ligne?.identifiantCompteTiers);

  getComponent = function getComponent(
    data: any,
    onChange: any,
    handlePin: any,
  ): React.ReactElement {
    return (
      <CompteDeTiersComponent
        data={data}
        handlePin={handlePin}
        onChange={onChange}
        panel={this}
      />
    );
  };
}

export default CompteDeTiersPanel;
